(()=>{
  const root=document.documentElement;
  const header=document.querySelector('.site-header');
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const updateHeader=()=>header&&header.classList.toggle('scrolled',window.scrollY>35);
  updateHeader();window.addEventListener('scroll',updateHeader,{passive:true});

  if('IntersectionObserver' in window&&!reduceMotion){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('in');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -40px'});
    document.querySelectorAll('.reveal').forEach((el,index)=>{el.style.transitionDelay=`${Math.min((index%4)*.07,.21)}s`;observer.observe(el)});
  }else document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));

  let mouseX=innerWidth*.5,mouseY=innerHeight*.25,visualX=mouseX,visualY=mouseY,mouseRaf=0;
  const renderMouse=()=>{visualX+=(mouseX-visualX)*.09;visualY+=(mouseY-visualY)*.09;root.style.setProperty('--mx',visualX+'px');root.style.setProperty('--my',visualY+'px');if(Math.abs(mouseX-visualX)>.1||Math.abs(mouseY-visualY)>.1)mouseRaf=requestAnimationFrame(renderMouse);else mouseRaf=0};
  window.addEventListener('pointermove',event=>{mouseX=event.clientX;mouseY=event.clientY;if(!mouseRaf)mouseRaf=requestAnimationFrame(renderMouse)},{passive:true});

  document.querySelectorAll('[data-cursor-logo]').forEach(logo=>{
    const hero=logo.closest('.hero')||logo.parentElement;if(!hero||reduceMotion)return;
    let tx=0,ty=0,cx=0,cy=0,rx=0,ry=0,raf=0;
    const animate=()=>{cx+=(tx-cx)*.085;cy+=(ty-cy)*.085;rx+=(ty*.10-rx)*.075;ry+=(-tx*.10-ry)*.075;logo.style.transform=`translate3d(${cx}px,${cy}px,0) rotateX(${rx}deg) rotateY(${ry}deg)`;if(Math.abs(tx-cx)>.02||Math.abs(ty-cy)>.02||Math.abs(rx)>.02||Math.abs(ry)>.02)raf=requestAnimationFrame(animate);else raf=0};
    const start=()=>{if(!raf)raf=requestAnimationFrame(animate)};
    hero.addEventListener('pointermove',event=>{const r=hero.getBoundingClientRect();const nx=(event.clientX-r.left)/r.width-.5;const ny=(event.clientY-r.top)/r.height-.5;tx=nx*42;ty=ny*28;start()},{passive:true});
    hero.addEventListener('pointerleave',()=>{tx=0;ty=0;start()},{passive:true});
  });

  document.querySelectorAll('.product-card,.review,.split-image').forEach(card=>{
    if(reduceMotion)return;
    card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect();card.style.setProperty('--card-x',`${((e.clientX-r.left)/r.width)*100}%`);card.style.setProperty('--card-y',`${((e.clientY-r.top)/r.height)*100}%`)},{passive:true});
  });

  document.querySelectorAll('[data-collection-filters]').forEach(filters=>{
    const grid=filters.parentElement.querySelector('[data-collection-grid]');
    const empty=filters.parentElement.querySelector('[data-collection-empty]');
    if(!grid)return;
    const cards=[...grid.querySelectorAll('[data-product-category]')];
    filters.querySelectorAll('[data-collection-filter]').forEach(button=>{
      button.addEventListener('click',()=>{
        const category=button.dataset.collectionFilter;
        let visible=0;
        filters.querySelectorAll('[data-collection-filter]').forEach(item=>{
          const active=item===button;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-pressed',String(active));
        });
        cards.forEach(card=>{
          const show=category==='all'||card.dataset.productCategory===category;
          card.hidden=!show;
          if(show)visible++;
        });
        if(empty)empty.hidden=visible!==0;
        grid.hidden=visible===0;
      });
    });
  });
})();

// Once-per-local-day offer game with email capture + instant code reveal.
(()=>{
  document.querySelectorAll('[data-offer-game]').forEach(game=>{

    const key='stoic-offer-game-day';

    const localDay=()=>{
      const now=new Date();
      return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
    };

    const alreadySeen=localStorage.getItem(key)===localDay();

    const pageKey='stoic-offer-page-views';
    const pageViews=Number(sessionStorage.getItem(pageKey)||0)+1;
    sessionStorage.setItem(pageKey,String(pageViews));

    const panel=game.querySelector('.offer-game-panel');
    const launcher=document.querySelector('[data-game-launch]');
    const play=game.querySelector('[data-game-play]');
    const playLabel=play?.textContent.trim()||'Play & reveal my offer';

    const board=game.querySelector('[data-game-board]');
    const gem=game.querySelector('[data-game-gem]');
    const result=game.querySelector('[data-game-result]');
    const status=game.querySelector('[data-game-status] strong');

    const rewardsNode=game.querySelector('[data-game-rewards]');
    const claimForm=game.querySelector('.offer-game-email-form');
    const claimPanel=game.querySelector('[data-game-claim]');
    const claimedPanel=game.querySelector('[data-game-claimed]');
    const formError=game.querySelector('[data-game-form-error]');

    const emailInput=game.querySelector('[data-game-email]');
    const claimButton=game.querySelector('[data-game-claim-button]');
    const codeButton=game.querySelector('[data-game-code]');

    let selectedReward=null;
    let rewards=[];

    try{
      rewards=JSON.parse(
        rewardsNode?.textContent||'[]'
      );
    }catch(error){
      console.error(
        'Stoic offer game: could not load rewards.',
        error
      );
      rewards=[];
    }

    if(!rewards.length){
      launcher?.setAttribute('hidden','');
      return;
    }

    /*
     * RESET GAME
     */
    const reset=()=>{

      panel?.classList.remove(
        'is-playing',
        'is-result'
      );

      if(claimPanel){
        claimPanel.hidden=true;
      }

      if(claimedPanel){
        claimedPanel.hidden=true;
      }

      if(play){
        play.disabled=false;
        play.textContent=playLabel;
      }

      if(claimButton){
        claimButton.disabled=true;
        claimButton.textContent='Unlock my code';
      }

      if(result){
        result.classList.remove('is-unlocked');
      }

      const resultLabel=
        result?.querySelector(
          '[data-game-result-label]'
        );

      if(resultLabel){
        resultLabel.textContent='Play to reveal';
      }

      if(status){
        status.textContent='Ready to drop';
      }

      if(formError){
        formError.hidden=true;
        formError.textContent=
          'Please enter a valid email address.';
      }

      if(emailInput){
        emailInput.value='';
      }

      if(gem){
        gem.getAnimations().forEach(
          animation=>animation.cancel()
        );
        gem.removeAttribute('style');
      }

      if(codeButton){
        codeButton.textContent='CODE';
        codeButton.dataset.code='';
      }

      selectedReward=null;
    };

    /*
     * OPEN / CLOSE
     */
    const open=()=>{
      game.hidden=false;
      document.body.classList.add('offer-game-open');
      panel?.focus();
    };

    const close=()=>{
      game.hidden=true;
      document.body.classList.remove('offer-game-open');
      localStorage.setItem(key,localDay());
    };

    launcher?.addEventListener(
      'click',
      ()=>{
        reset();
        open();
      }
    );

    game.querySelectorAll(
      '[data-game-close]'
    ).forEach(button=>{
      button.addEventListener(
        'click',
        close
      );
    });

    document.addEventListener(
      'keydown',
      event=>{
        if(
          event.key==='Escape' &&
          !game.hidden
        ){
          close();
        }
      }
    );

    /*
     * GEM DROP ANIMATION
     */
    const animateDrop=(rewardIndex)=>{

      if(!board||!gem){
        return Promise.resolve();
      }

      const boardRect=
        board.getBoundingClientRect();

      const rows=[
        ...board.querySelectorAll(
          '.offer-game-row'
        )
      ];

      const slots=[
        ...board.querySelectorAll(
          '[data-game-slot]'
        )
      ];

      const targetSlot=
        slots[
          Math.min(
            rewardIndex,
            slots.length-1
          )
        ]||slots[0];

      if(
        !targetSlot||
        !rows.length
      ){
        return Promise.resolve();
      }

      const targetRect=
        targetSlot.getBoundingClientRect();

      const targetX=
        targetRect.left-
        boardRect.left+
        targetRect.width/2;

      let currentX=
        boardRect.width/2;

      let rotation=0;

      const frames=[
        {
          left:`${currentX}px`,
          top:'34px',
          transform:
            `translate(-50%,-50%) rotate(${rotation}deg)`,
          offset:0
        }
      ];

      const hitPegs=[];

      rows.forEach(
        (row,rowIndex)=>{

          const pegs=[
            ...row.querySelectorAll(
              '[data-game-peg]'
            )
          ];

          const progress=
            (rowIndex+1)/
            (rows.length+1);

          const idealX=
            currentX+
            (targetX-currentX)*
            (.28+progress*.18);

          const peg=
            pegs.reduce(
              (closest,candidate)=>{

                const rect=
                  candidate.getBoundingClientRect();

                const x=
                  rect.left-
                  boardRect.left+
                  rect.width/2;

                return(
                  !closest||
                  Math.abs(x-idealX)<
                  Math.abs(
                    closest.x-idealX
                  )
                )
                ?{
                  node:candidate,
                  x,
                  rect
                }
                :closest;

              },
              null
            );

          if(!peg)return;

          const hitY=
            peg.rect.top-
            boardRect.top+
            peg.rect.height/2;

          rotation+=
            55+
            Math.random()*35;

          frames.push({
            left:`${peg.x}px`,
            top:`${hitY-5}px`,
            transform:
              `translate(-50%,-50%) rotate(${rotation}deg)`
          });

          const direction=
            targetX>peg.x?1:-1;

          const alternating=
            rowIndex%2===0
              ?direction
              :-direction;

          const bounce=
            Math.max(
              15,
              Math.min(
                38,
                boardRect.width*.045
              )
            );

          currentX=
            peg.x+
            alternating*bounce;

          rotation+=
            45+
            Math.random()*30;

          frames.push({
            left:`${currentX}px`,
            top:`${hitY+16}px`,
            transform:
              `translate(-50%,-50%) rotate(${rotation}deg)`
          });

          hitPegs.push(
            peg.node
          );

        }
      );

      rotation+=150;

      frames.push({
        left:`${targetX}px`,
        top:
          `${targetRect.top-
            boardRect.top-8}px`,
        transform:
          `translate(-50%,-50%) rotate(${rotation}deg)`
      });

      frames.push({
        left:`${targetX}px`,
        top:
          `${targetRect.top-
            boardRect.top+
            targetRect.height*.38}px`,
        transform:
          `translate(-50%,-50%) rotate(${rotation+70}deg)`
      });

      frames.forEach(
        (frame,index)=>{
          frame.offset=
            index/
            (frames.length-1);
        }
      );

      const duration=3300;

      const animation=
        gem.animate(
          frames,
          {
            duration,
            easing:
              'cubic-bezier(.32,.04,.42,1)',
            fill:'forwards'
          }
        );

      hitPegs.forEach(
        (peg,index)=>{

          setTimeout(
            ()=>{

              peg.classList.add(
                'is-hit'
              );

              setTimeout(
                ()=>{
                  peg.classList.remove(
                    'is-hit'
                  );
                },
                180
              );

            },
            Math.round(
              duration*
              (
                (index*2+1)/
                (frames.length-1)
              )
            )
          );

        }
      );

      return animation.finished.catch(
        ()=>{}
      );
    };

    /*
     * PLAY GAME
     */
    play?.addEventListener(
      'click',
      async()=>{

        if(play.disabled)return;

        play.disabled=true;

        panel?.classList.add(
          'is-playing'
        );

        board?.classList.add(
          'is-dropping'
        );

        if(status){
          status.textContent=
            'Finding your offer…';
        }

        const total=
          rewards.reduce(
            (sum,reward)=>
              sum+
              Math.max(
                1,
                Number(reward.weight)||1
              ),
            0
          );

        let draw=
          Math.random()*total;

        const reward=
          rewards.find(item=>{

            draw-=
              Math.max(
                1,
                Number(item.weight)||1
              );

            return draw<=0;

          })||rewards[0];

        selectedReward=reward;

        await animateDrop(
          Math.max(
            0,
            rewards.indexOf(reward)
          )
        );

        /*
         * SHOW WINNING REWARD
         */
        if(result){

          const resultLabel=
            result.querySelector(
              '[data-game-result-label]'
            );

          if(resultLabel){
            resultLabel.textContent=
              `You unlocked ${reward.label}`;
          }

          result.classList.add(
            'is-unlocked'
          );
        }

        panel?.classList.remove(
          'is-playing'
        );

        panel?.classList.add(
          'is-result'
        );

        if(status){
          status.textContent=
            'Offer unlocked';
        }

        if(play){
          play.textContent=
            'Deal revealed';
        }

        /*
         * SHOW EMAIL CLAIM
         */
        if(claimPanel){
          claimPanel.hidden=false;
        }

        if(claimButton){
          claimButton.disabled=true;
          claimButton.textContent=
            'Unlock my code';
        }

        /*
         * TAG CUSTOMER WITH REWARD
         */
        const rewardTag=
          claimForm?.querySelector(
            '[data-game-tags]'
          );

        if(rewardTag){

          const safeCode=
            String(
              reward.code||'offer'
            )
            .replace(
              /[^a-z0-9_-]/gi,
              '-'
            )
            .toLowerCase();

          rewardTag.value=
            `newsletter,stoic-offer-game,stoic-reward-${safeCode}`;
        }

        setTimeout(
          ()=>{
            emailInput?.focus({
              preventScroll:true
            });
          },
          150
        );

        localStorage.setItem(
          key,
          localDay()
        );

      }
    );

    /*
     * ENABLE CLAIM BUTTON ONLY WHEN
     * A VALID EMAIL HAS BEEN ENTERED
     */
    emailInput?.addEventListener(
      'input',
      ()=>{

        const valid=
          emailInput.checkValidity() &&
          emailInput.value.trim()!=='';

        if(claimButton){
          claimButton.disabled=!valid;
        }

        if(formError){
          formError.hidden=true;
        }

      }
    );

    /*
 /*
 /*
 /*
 * SUBMIT EMAIL WITHOUT RELOADING PAGE
 * Uses a real native form submission into a hidden iframe (see
 * discount-game.liquid) so Shopify gets an unmodified request — this
 * avoids captcha/field issues that broke the earlier fetch() version —
 * while the visible page never navigates or reloads.
 */
if(claimForm){

  claimForm.setAttribute('target','stoic-offer-game-target');

  const targetFrame=document.querySelector('iframe[name="stoic-offer-game-target"]');

  claimForm.addEventListener('submit', event => {

    if(!emailInput?.checkValidity()){
      event.preventDefault();
      emailInput?.reportValidity();
      if(formError)formError.hidden=false;
      return;
    }

    if(formError)formError.hidden=true;

    if(claimButton){
      claimButton.disabled=true;
      claimButton.textContent='Claiming…';
    }

    let revealed=false;

    const revealCode=()=>{
      if(revealed)return;
      revealed=true;
      if(codeButton&&selectedReward){
        codeButton.textContent=selectedReward.code||'SEE TERMS';
        codeButton.dataset.code=selectedReward.code||'';
      }
      if(claimPanel)claimPanel.hidden=true;
      if(claimedPanel)claimedPanel.hidden=false;
      if(status)status.textContent='Your code is ready';
      targetFrame?.removeEventListener('load',revealCode);
    };

    targetFrame?.addEventListener('load',revealCode);

    // Fallback in case the iframe's load event doesn't fire as expected
    setTimeout(revealCode,2500);

    // No event.preventDefault() here — the form submits natively into
    // the hidden iframe, so Shopify gets a normal request and the
    // visible page never navigates.
  });

}

    /*
     * COPY DISCOUNT CODE
     */
    codeButton?.addEventListener(
      'click',
      async event=>{

        const button=
          event.currentTarget;

        const code=
          button.dataset.code;

        if(!code)return;

        try{

          await navigator.clipboard.writeText(
            code
          );

          button.textContent=
            'COPIED';

          setTimeout(
            ()=>{
              button.textContent=code;
            },
            1600
          );

        }catch(error){

          /*
           * Clipboard fallback
           */
          const textarea=
            document.createElement(
              'textarea'
            );

          textarea.value=code;

          textarea.style.position=
            'fixed';

          textarea.style.opacity='0';

          document.body.appendChild(
            textarea
          );

          textarea.select();

          try{
            document.execCommand(
              'copy'
            );
          }catch(copyError){}

          textarea.remove();

          button.textContent=
            'COPIED';

          setTimeout(
            ()=>{
              button.textContent=code;
            },
            1600
          );

        }

      }
    );

    /*
     * AUTOMATIC GAME DISPLAY
     */
    const requiredPages=
      Math.max(
        1,
        Number(game.dataset.pages)||2
      );

    if(
      !alreadySeen &&
      pageViews>=requiredPages
    ){

      setTimeout(
        open,
        Math.max(
          5000,
          Number(game.dataset.delay)||15000
        )
      );

    }

  });
})();

// Product gallery, variant media and quantity controls
(()=>{
  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const slides=[...section.querySelectorAll('.luxury-gallery-slide')];
    const thumbs=[...section.querySelectorAll('[data-gallery-thumb]')];
    const current=section.querySelector('[data-gallery-current]');
    let active=0;
    const show=index=>{
      if(!slides.length)return;
      active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{const on=i===active;slide.classList.toggle('is-active',on);slide.hidden=!on});
      thumbs.forEach((thumb,i)=>{const on=i===active;thumb.classList.toggle('is-active',on);thumb.setAttribute('aria-selected',String(on))});
      if(current)current.textContent=String(active+1);
      thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    };
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    section.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(active-1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));

    const qty=section.querySelector('[data-qty-input]');
    section.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{if(qty)qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});
    section.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{if(qty)qty.value=(parseInt(qty.value,10)||1)+1});

    const select=section.querySelector('[data-variant-select]');
    if(select){
      const choices=[...section.querySelectorAll('[data-variant-choice]')];
      const updateVariant=()=>{
        const option=select.options[select.selectedIndex];
        const available=option.dataset.available==='true';
        const price=section.querySelector('[data-product-price]');
        const installmentPrice=section.querySelector('[data-installment-price]');
        const compare=section.querySelector('[data-product-compare-price]');
        const status=section.querySelector('[data-product-status]');
        const button=section.querySelector('[data-add-to-cart]');
        const label=section.querySelector('[data-add-label]');
        if(price)price.textContent=option.dataset.price||'';
        if(installmentPrice)installmentPrice.textContent=option.dataset.installmentPrice||'';
        if(compare){compare.textContent=option.dataset.comparePrice||'';compare.hidden=!option.dataset.comparePrice}
        const salePercent=section.querySelector('[data-sale-percent]');
        if(salePercent){
          const savings=Number(option.dataset.savings)||0;
          const savingsMoney=option.dataset.savingsMoney||'';
          salePercent.textContent=savingsMoney ? `You save ${savingsMoney} (${savings}%)` : `Save ${savings}%`;
          salePercent.parentElement.hidden=savings<1;
        }
        const stickyPrice=document.querySelector('[data-sticky-price]');
        if(stickyPrice)stickyPrice.textContent=option.dataset.price||'';
        const stickyAdd=document.querySelector('[data-sticky-add]');
        if(stickyAdd){stickyAdd.disabled=!available;stickyAdd.textContent=available?'Add to bag':'Sold out'}
        if(status){status.textContent=available?'In stock · ready to ship':'Currently unavailable';status.classList.toggle('is-sold-out',!available)}
        if(button)button.disabled=!available;
        if(label)label.textContent=available?'Add to bag':'Sold out';
        const mediaId=option.dataset.featuredMediaId;
        if(mediaId){const index=slides.findIndex(slide=>slide.dataset.mediaId===mediaId);if(index>=0)show(index)}
        const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
        choices.forEach(choice=>choice.classList.toggle('is-selected',choice.dataset.variantChoice===option.value));
      };
      select.addEventListener('change',updateVariant);
      choices.forEach(choice=>choice.addEventListener('click',()=>{
        select.value=choice.dataset.variantChoice;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }));
    }
  });
})();

// Add the real Shopify bundle product in one action.
(()=>{
  document.querySelectorAll('[data-bundle-form]').forEach(form=>{
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('[data-bundle-submit]');
      const id=Number(form.querySelector('[data-bundle-variant]')?.value);
      if(!id||!button)return;
      const original=button.textContent;
      button.disabled=true;button.textContent='Adding your set…';
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if(!response.ok)throw new Error('Unable to add set');
        window.location.href=`${root}cart`;
      }catch(error){
        button.disabled=false;button.textContent='Please try again';
        setTimeout(()=>button.textContent=original,2200);
      }
    });
  });
})();

// Convert separately added component products into their real bundle product.
// One complete group is replaced at a time; surplus quantities stay in the bag.
(()=>{
  const element=document.querySelector('[data-cart-bundle-converter]');
  if(!element)return;

  const number=value=>{
    const parsed=Number(value);
    return Number.isFinite(parsed)&&parsed>0?parsed:0;
  };
  const configurations=[
    {
      variantId:number(element.dataset.essentialBundleVariant),
      productIds:[number(element.dataset.essentialProductOne),number(element.dataset.essentialProductTwo)]
    },
    {
      variantId:number(element.dataset.radiantBundleVariant),
      productIds:[number(element.dataset.radiantProductOne),number(element.dataset.radiantProductTwo),number(element.dataset.radiantProductThree)]
    }
  ].filter(configuration=>configuration.variantId&&configuration.productIds.length>1&&configuration.productIds.every(Boolean));

  if(!configurations.length)return;

  const root=window.Shopify?.routes?.root||'/';
  const convert=async()=>{
    try{
      const cartResponse=await fetch(`${root}cart.js`,{headers:{'Accept':'application/json'}});
      if(!cartResponse.ok)return;
      const cart=await cartResponse.json();

      for(const configuration of configurations){
        const standaloneItems=cart.items.filter(item=>{
          const isComponent=Boolean(item.parent_relationship||item.parent_id);
          return !isComponent&&configuration.productIds.includes(Number(item.product_id));
        });
        const quantities=configuration.productIds.map(productId=>
          standaloneItems
            .filter(item=>Number(item.product_id)===productId)
            .reduce((total,item)=>total+Number(item.quantity||0),0)
        );
        const bundleQuantity=Math.min(...quantities);
        if(bundleQuantity<1)continue;

        const addResponse=await fetch(`${root}cart/add.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:configuration.variantId,quantity:bundleQuantity}]})
        });
        if(!addResponse.ok)throw new Error('Unable to add bundle');

        const updates={};
        for(const productId of configuration.productIds){
          let remaining=bundleQuantity;
          for(const item of standaloneItems.filter(line=>Number(line.product_id)===productId)){
            const reduction=Math.min(remaining,Number(item.quantity||0));
            updates[item.key]=Number(item.quantity||0)-reduction;
            remaining-=reduction;
            if(remaining<=0)break;
          }
        }
        const updateResponse=await fetch(`${root}cart/update.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates})
        });
        if(!updateResponse.ok)throw new Error('Unable to replace bundle pieces');
        window.location.reload();
        return;
      }
    }catch(error){
      document.documentElement.dataset.bundleConversionError='true';
    }
  };
  convert();
})();

// Compact catalogue tabs prevent long category stacks on small screens.
(()=>{
  document.querySelectorAll('[data-catalog-tabs]').forEach(section=>{
    const tabs=[...section.querySelectorAll('[data-catalog-tab]')];
    const panels=[...section.querySelectorAll('[data-catalog-panel]')];
    const activate=id=>{
      tabs.forEach(tab=>{
        const active=tab.dataset.catalogTab===id;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',String(active));
      });
      panels.forEach(panel=>{
        const active=panel.dataset.catalogPanel===id;
        panel.classList.toggle('is-active',active);
        panel.hidden=!active;
      });
    };
    tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab.dataset.catalogTab)));
  });
})();

// Add the one missing set component directly from the bag recommendation.
(()=>{
  document.querySelectorAll('[data-cart-bundle-add]').forEach(button=>{
    button.addEventListener('click',async()=>{
      const id=Number(button.dataset.cartBundleAdd);
      if(!id)return;
      const original=button.textContent;
      button.disabled=true;
      button.textContent='Adding piece…';
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if(!response.ok)throw new Error('Unable to add piece');
        window.location.reload();
      }catch(error){
        button.disabled=false;
        button.textContent='Please try again';
        setTimeout(()=>button.textContent=original,2200);
      }
    });
  });
})();

// Designed cart quantity controls retain Shopify's standard update workflow.
(()=>{
  document.querySelectorAll('.cart-quantity').forEach(control=>{
    const input=control.querySelector('input');
    control.querySelector('[data-cart-minus]')?.addEventListener('click',()=>{input.value=Math.max(0,(Number(input.value)||0)-1)});
    control.querySelector('[data-cart-plus]')?.addEventListener('click',()=>{input.value=(Number(input.value)||0)+1});
  });
})();

// Lightweight support panel with an honest response-time expectation.
(()=>{
  const chat=document.querySelector('[data-stoic-chat]');
  if(!chat)return;
  const panel=chat.querySelector('[data-chat-panel]');
  chat.querySelector('[data-chat-toggle]')?.addEventListener('click',()=>{
    const open=panel.hidden;
    panel.hidden=!open;
    chat.classList.toggle('is-open',open);
  });
  chat.querySelector('[data-chat-close]')?.addEventListener('click',()=>{panel.hidden=true;chat.classList.remove('is-open')});
})();

// Honest promotion countdowns: once the configured deadline passes, urgency copy expires.
(()=>{
  const clocks=[...document.querySelectorAll('[data-sale-countdown]')];
  if(!clocks.length)return;
  const render=()=>{
    const now=Date.now();
    clocks.forEach(clock=>{
      const end=Date.parse(clock.dataset.saleEnd||'');
      const output=clock.querySelector('[data-countdown-output]');
      if(!output)return;
      if(!Number.isFinite(end)||end<=now){
        output.textContent=clock.dataset.saleExpired||'Event pricing has ended';
        clock.classList.add('is-expired');
        return;
      }
      const seconds=Math.floor((end-now)/1000);
      const days=Math.floor(seconds/86400);
      const hours=Math.floor((seconds%86400)/3600);
      const minutes=Math.floor((seconds%3600)/60);
      const secs=seconds%60;
      output.textContent=days>0?`${days}d ${hours}h ${minutes}m`:`${hours}h ${minutes}m ${secs}s`;
    });
  };
  render();
  setInterval(render,1000);
})();

// Mobile sticky purchase bar mirrors the main product form.
(()=>{
  const bar=document.querySelector('[data-sticky-purchase]');
  const form=document.querySelector('[data-product-form]');
  const mainButton=document.querySelector('[data-add-to-cart]');
  const stickyButton=document.querySelector('[data-sticky-add]');
  if(!bar||!form||!mainButton||!stickyButton)return;
  stickyButton.addEventListener('click',()=>{
    if(mainButton.disabled)return;
    if(typeof form.requestSubmit==='function')form.requestSubmit(mainButton);
    else mainButton.click();
  });
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>bar.classList.toggle('is-visible',!entry.isIntersecting));
    },{threshold:.15});
    observer.observe(mainButton);
  }
})();

// Rotating announcement bar
(()=>{
  document.querySelectorAll('[data-announcement-bar]').forEach(bar=>{
    const messages=[...bar.querySelectorAll('[data-announcement-message]')];
    if(messages.length<1)return;
    let active=Math.max(0,messages.findIndex(message=>message.classList.contains('is-active')));
    let timer;
    const speed=Math.max(3000,Number(bar.dataset.speed)||5000);
    const auto=bar.dataset.rotate==='true';
    const show=index=>{
      const next=(index+messages.length)%messages.length;
      messages.forEach((message,i)=>{
        const on=i===next;
        message.hidden=false;
        requestAnimationFrame(()=>message.classList.toggle('is-active',on));
        if(!on)setTimeout(()=>{if(!message.classList.contains('is-active'))message.hidden=true},450);
      });
      active=next;
    };
    const stop=()=>{if(timer){clearInterval(timer);timer=undefined}};
    const start=()=>{if(auto&&messages.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){stop();timer=setInterval(()=>show(active+1),speed)}};
    bar.querySelector('[data-announcement-prev]')?.addEventListener('click',()=>{show(active-1);start()});
    bar.querySelector('[data-announcement-next]')?.addEventListener('click',()=>{show(active+1);start()});
    bar.addEventListener('mouseenter',stop);
    bar.addEventListener('mouseleave',start);
    bar.addEventListener('focusin',stop);
    bar.addEventListener('focusout',start);
    start();
  });
})();